import { Box, Stack, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import { getProximosEventos } from '../services/apis';

const formatToday = () => {
    const date = new Date();
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const minutesFromNow = (hora) => {
    if (!hora) {
        return Number.MAX_SAFE_INTEGER;
    }

    const [hours, minutes] = hora.split(':').map(Number);
    const now = new Date();
    const eventDate = new Date();
    eventDate.setHours(hours || 0, minutes || 0, 0, 0);

    return Math.abs(eventDate.getTime() - now.getTime());
};

const eventIcon = {
    comida: <RestaurantIcon fontSize="small" />,
    limpieza: <CleaningServicesIcon fontSize="small" />,
    actividad: <LocalActivityIcon fontSize="small" />,
    ropa: <CheckroomIcon fontSize="small" />,
};

export const SideTodayEvents = () => {
    const [loaded, setLoaded] = useState(false);
    const [agenda, setAgenda] = useState(null);

    useEffect(() => {
        const cargarAgenda = async () => {
            try {
                const response = await getProximosEventos(formatToday());
                if (response?.success) {
                    setAgenda(response.data);
                }
            } catch (error) {
                console.error('Error en carregar l?agenda lateral:', error);
            } finally {
                setLoaded(true);
            }
        };

        cargarAgenda();
    }, []);

    const eventos = useMemo(() => {
        if (!agenda) {
            return [];
        }

        const comidas = (agenda.comidas || []).map((evento) => ({
            tipo: 'comida',
            titulo: evento.comida || evento.descripcion || 'Menjar',
            detalle: evento.cocineros?.join(', ') || '',
            hora: evento.hora || '',
        }));
        const limpieza = (agenda.limpieza || []).map((evento) => ({
            tipo: 'limpieza',
            titulo: evento.descripcion || 'Neteja',
            detalle: evento.limpiadores?.join(', ') || '',
            hora: evento.hora || '',
        }));
        const actividades = (agenda.actividades || []).map((evento) => ({
            tipo: 'actividad',
            titulo: evento.actividad || evento.descripcion || 'Activitat',
            detalle: evento.encargado?.join(', ') || '',
            hora: evento.hora || '',
        }));
        const ropa = (agenda.ropa || []).map((evento) => ({
            tipo: 'ropa',
            titulo: evento.descripcion || 'Ropa',
            detalle: '',
            hora: evento.hora || '',
        }));

        return [...comidas, ...limpieza, ...actividades, ...ropa]
            .sort((a, b) => minutesFromNow(a.hora) - minutesFromNow(b.hora))
            .slice(0, 5);
    }, [agenda]);

    if (!loaded) {
        return null;
    }

    return (
        <Box className="side-info-card">
            <Box className="side-info-heading">
                <EventAvailableIcon fontSize="small" />
                <Typography className="side-widget-title">Avui</Typography>
            </Box>

            {eventos.length === 0 ? (
                <Typography className="side-empty-text">Sense esdeveniments avui</Typography>
            ) : (
                <Stack className="side-event-list">
                    {eventos.map((evento, index) => (
                        <Box key={`${evento.tipo}-${evento.hora}-${index}`} className={`side-event-row side-event-${evento.tipo}`}>
                            <Box className="side-event-icon">
                                {eventIcon[evento.tipo] || eventIcon.actividad}
                            </Box>
                            <Box className="side-event-copy">
                                <Typography className="side-event-title">{evento.titulo}</Typography>
                                <Typography className="side-event-meta">
                                    {evento.hora || '--:--'}{evento.detalle ? ` · ${evento.detalle}` : ''}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Stack>
            )}
        </Box>
    );
};
